// Use exactly the explicit-media-time interpretation of ReplayTimestampNormalizer.
// Do not use ASR receive/create times to manufacture a seek target.
export function sentenceRange(sentence, playback) {
  if (playback?.status !== 'AVAILABLE') return null
  const start = playback.captureStartedAtMs
  const end = playback.captureEndedAtMs
  if (!Number.isFinite(start) || !Number.isFinite(end) || start <= 0 || end <= start) return null
  const duration = end - start
  const relative = (raw) => {
    if (!Number.isFinite(raw) || raw < 0) return null
    return raw <= duration + 60000 ? raw : raw - start
  }
  const from = relative(sentence.startTimeMs)
  const to = relative(sentence.endTimeMs)
  if (from == null || to == null || from < 0 || from >= duration || to <= from) return null
  const mediaEnd = playback.mediaDurationMs
  if (Number.isFinite(mediaEnd) && from >= mediaEnd) return null
  return { start: from, end: Math.min(to, duration, Number.isFinite(mediaEnd) ? mediaEnd : duration) }
}

export function formatTranscriptTime(ms) {
  if (!Number.isFinite(ms) || ms < 0) return '—'
  const seconds = Math.floor(ms / 1000)
  const parts = [Math.floor(seconds / 60) % 60, seconds % 60]
  if (seconds >= 3600) parts.unshift(Math.floor(seconds / 3600))
  return parts.map((part) => String(part).padStart(2, '0')).join(':')
}

export function activeSentence(items, positionMs, playback) {
  return (
    items.find((item) => {
      const range = sentenceRange(item, playback)
      return range && range.start <= positionMs && positionMs < range.end
    })?.id || null
  )
}

// Decimal string arithmetic keeps Snowflake IDs exact without requiring BigInt support.
export function previousSentenceCursor(id) {
  const digits = String(id).split('')
  if (!/^[1-9][0-9]*$/.test(id)) return null
  for (let i = digits.length - 1; i >= 0; i--) {
    if (digits[i] !== '0') {
      digits[i] = String(Number(digits[i]) - 1)
      break
    }
    digits[i] = '9'
  }
  const previous = digits.join('').replace(/^0+/, '')
  return previous || null
}

export function transcriptPlaybackLabel(playback) {
  const labels = {
    ARCHIVED: '原声已归档，尚未准备播放音轨',
    QUEUED: '原声排队中',
    PROCESSING: '正在准备原声',
    FAILED: '原声准备失败',
    RECORDING: '原声尚未完成归档',
    SOURCE_UNAVAILABLE: '原声服务暂不可用',
  }
  if (playback.reasonCode === 'AUDIO_ARCHIVE_UNREADABLE') return '原声归档不可用或无法解码，可重试准备'
  if (playback.reasonCode === 'WORKER_INTERRUPTED') return '原声准备任务中断，可重试准备'
  if (playback.reasonCode === 'CAPTURE_TOO_LONG') return '本场录音超过 6 小时，暂不支持准备'
  if (playback.reasonCode === 'NO_AUDIO_ARCHIVE') return '未找到原声归档'
  return labels[playback.status] || '暂无可播放原声'
}
